<template>
  <v-container fluid>
    <v-row v-if="isLoading">
      <v-col>
        <loading-spinner></loading-spinner>
      </v-col>
    </v-row>
    <v-row v-else>
      <v-col col="12" xl="4" md="12" xs="12">
        <search-box :title="$t('title.search')" :fields="searchBoxFields" v-model="conditions">
          <template v-slot:buttons>
            <v-card-actions class="justify-end">
              <custom-button @click="search" :label="$t('button.search')" color="primary" size="lg" gradient
                rounded></custom-button>
            </v-card-actions>
          </template>
        </search-box>
      </v-col>

      <v-col col="12" xl="8" md="12" xs="12">
        <paginated-table v-if="!isLoading" :data="payments" :columns="tableColumns"
          :title="$t('title.payment_management')" @updatePagination="updatePagination">

          <template slot="bottom-buttons">
            <div class="mt-5 mb-3 ml-2">
              <custom-button @click="excelDownload" :label="$t('button.excel_download')" color="green" size="lg"
                gradient rounded></custom-button>
            </div>
          </template>
        </paginated-table>
      </v-col>
    </v-row>

    <info-modal :data="currentPayment" :isVisible="showDetailInfo" @close="showDetailInfo = false"></info-modal>

  </v-container>
</template>

<script>
import SearchBox from "@/components/SearchBoxs/SearchBox.vue";
import PaginatedTable from "@/components/Tables/PaginatedTable.vue";
import InfoModal from "@/components/cards/InfoModal.vue";

import { paymentSearchBoxInfo } from "@/views/AccountView/fields";
import { getPaymentColumns } from "@/views/AccountView/columns";
import { paymentMangementLabel } from "@/views/AccountView/label";

import { accountApi } from "@/api/api"
import LoadingSpinner from '@/components/common/Spinners/LoadingSpinner.vue';
import CustomButton from '@/components/common/buttons/CustomButton.vue';

import * as Xlsx from 'xlsx'

export default {
  components: {
    SearchBox,
    PaginatedTable,
    InfoModal,
    LoadingSpinner,
    CustomButton,
  },
  data() {
    return {
      // labels 
      titles: paymentMangementLabel.titles,
      buttons: paymentMangementLabel.buttons,
      searchBoxTitle: paymentSearchBoxInfo.title,

      // fields & columns 
      searchBoxFields: paymentSearchBoxInfo.fields,
      tableColumns: getPaymentColumns({ showDetail: this.showDetail }),

      // boolean
      isLoading: false,
      showDetailInfo: false,

      // init data
      payments: {
        page_info: {
          page: 1,
          size: 5,
          total_elements: 5,
          total_pages: 1,
        },
        elements: [],
      },
      currentPayment: {},
      conditions: {
        startedAt: null,
        endedAt: null,
        name: null,
        payerEmail: null,
        payerName: null,
      },
    };
  },
  mounted() {
    this.fetchPayments(
      this.payments.page_info.size,
      this.payments.page_info.page,
      "approved_at",
      "desc"
    );
  },
  methods: {
    async search() {
      this.fetchPayments(
        this.payments.page_info.size,
        this.payments.page_info.page,
        "approved_at",
        "desc"
      );
    },
    async fetchPayments(size, page, sort_by, direction) {
      this.isLoading = true;
      const payments = await this.getPayments(size, page, sort_by, direction);

      if (payments) {
        this.payments = payments;
      }
      this.isLoading = false;
    },

    async getPayments(size, page, sort_by, direction) {
      const params = {
        size: size,
        page: page,
        sort_by: sort_by,
        direction: direction,
        payer_email: this.conditions.payerEmail,
        payer_name: this.conditions.payerName,
        started_at: this.conditions.startedAt,
        ended_at: this.conditions.endedAt,
        name: this.conditions.name,
      }

      const result = await accountApi.getPayments(params);

      if (result) {
        return result.data.response;
      }
      return null;
    },

    updatePagination(pagination) {
      this.payments.page_info.size = pagination.size
      this.payments.page_info.page = pagination.page

      this.fetchPayments(this.payments.page_info.size, this.payments.page_info.page);
    },

    async excelDownload() {
      this.isLoading = true;
      // 전체 데이터 가져오기
      const payments = await this.getPayments();
      const data = payments.elements;
      const selectedData = this.selectData(data);

      const workBook = Xlsx.utils.book_new();
      const workSheet = Xlsx.utils.json_to_sheet(selectedData);
      Xlsx.utils.book_append_sheet(workBook, workSheet, 'sheet1');
      Xlsx.writeFile(workBook, '회비내역.xlsx');
      this.isLoading = false;
    },

    selectData(data) {
      return data.map(item => ({
        "결제명": item.name,
        "결제자명": item.payer_name,
        "결제자 이메일": item.payer_email,
        "회원명": item.member_name,
        "회원 이메일": item.member_email,
        "결제 금액": item.amount,
        "결제 통화": item.currency_code,
        "승인일": item.approved_at,
      }))
    },

    showDetail(payment) {
      this.currentPayment = {
        payerName: {
          label: this.$t("label.payer_name"),
          value: payment.payer_name,
        },
        payerEmail: {
          label: this.$t("label.payer_email"),
          value: payment.payer_email,
        },
        memberName: {
          label: this.$t("label.member_name"),
          value: payment.member_name,
        },
        memberEmail: {
          label: this.$t("label.member_email"),
          value: payment.member_email,
        },
        amount: {
          label: this.$t("label.amount"),
          value: payment.amount,
        },
        crruencyCode: {
          label: this.$t("label.currency"),
          value: payment.currency_code,
        },
        approvedAt: {
          label: this.$t("label.approved_at"),
          value: payment.approved_at,
        },
      }

      this.showDetailInfo = !this.showDetailInfo;
    },
  },
};
</script>

<style lang="css" scoped></style>
